export const DEFAULT_PLACEHOLDER_TEXT = window.jQuery ? $.__('–Select–') : '–Select–';

export const DEFAULT_SIZE = 'medium';

export const DEFAULT_WIDTH = '3';
